import React,{useEffect,useRef} from 'react';
import {createPortal} from 'react-dom';

/**
 * Global portal modal.
 * Rendering at document.body prevents transformed/overflow parents from
 * clipping the dialog and keeps every Super Admin/Institute modal clickable.
 */
export default function Modal({open,title,subtitle,onClose,children,size='md',icon='✦',closeOnBackdrop=true}){
 const cardRef=useRef(null);
 const previousFocus=useRef(null);
 const onCloseRef=useRef(onClose);
 useEffect(()=>{onCloseRef.current=onClose},[onClose]);
 useEffect(()=>{
  if(!open)return undefined;
  previousFocus.current=document.activeElement;
  const previousOverflow=document.body.style.overflow;
  document.body.style.overflow='hidden';
  const handleKey=e=>{
   if(e.key==='Escape')onCloseRef.current?.();
   if(e.key==='Tab'&&cardRef.current){
    const focusable=[...cardRef.current.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')];
    if(!focusable.length)return;
    const first=focusable[0],last=focusable[focusable.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
   }
  };
  document.addEventListener('keydown',handleKey);
  const timer=window.setTimeout(()=>cardRef.current?.querySelector?.('input:not([type="hidden"]),select,textarea,button')?.focus?.(),0);
  return()=>{
   window.clearTimeout(timer);
   document.removeEventListener('keydown',handleKey);
   document.body.style.overflow=previousOverflow;
   previousFocus.current?.focus?.();
  };
 },[open]);
 if(!open||typeof document==='undefined')return null;
 const dialog=<div className="modal-backdrop global-modal-layer" role="presentation" onPointerDown={e=>{if(closeOnBackdrop&&e.target===e.currentTarget)onCloseRef.current?.()}}>
   <div ref={cardRef} className={`modal-card modal-${size}`} role="dialog" aria-modal="true" aria-label={title||'Dialog'} onPointerDown={e=>e.stopPropagation()}>
    <div className="modal-accent" aria-hidden="true"/>
    <div className="modal-header"><div className="modal-title-wrap"><span className="modal-title-icon">{icon}</span><div><small>SECURE WORKSPACE</small><h3>{title}</h3>{subtitle&&<p>{subtitle}</p>}</div></div><button type="button" className="icon-button modal-close" onClick={onClose} aria-label="Close">✕</button></div>
    <div className="modal-body">{children}</div>
   </div>
  </div>;
 return createPortal(dialog,document.body);
}
